module.exports = __webpack_public_path__ + "assets/img/AfterSale3.a26e3893.png";